import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import store from '@/store'
import initialize from '@/lib/initialize'

import { login } from '@/views/login/login.routes'
import { dashboard } from '@/views/dashboard/dashboard.routes'
import { schedule } from '@/views/schedule/schedule.routes'
import { sessions } from '@/views/sessions/sessions.routes'
import { session } from '@/views/session/session.routes'
import { presentations } from '@/views/presentations/presentations.routes'
import { presentation } from '@/views/presentation/presentation.routes'
import { persons } from '@/views/persons/persons.routes'
import { person } from '@/views/person/person.routes'
import { meetings } from '@/views/meetings/meetings.routes'
import { meeting } from '@/views/meeting/meeting.routes'
import { mailings } from '@/views/mailings/mailings.routes'
import { mailing } from '@/views/mailing/mailing.routes'
import { rooms } from '@/views/rooms/rooms.routes'
import { room } from '@/views/room/room.routes'
import { reports } from '@/views/reports/reports.routes'
import { tools } from '@/views/tools/tools.routes'
import { settings } from '@/views/settings/settings.routes'
import { preview } from '@/views/preview/preview.routes'

const router = new Router({
  routes: [
    ...login,
    ...dashboard,
    ...schedule,
    ...sessions,
    ...session,
    ...presentations,
    ...presentation,
    ...persons,
    ...person,
    ...meetings,
    ...meeting,
    ...mailings,
    ...mailing,
    ...rooms,
    ...room,
    ...reports,
    ...tools,
    ...settings,
    ...preview,
  ]
})

router.beforeEach(async (to, from, next) => {

  let app = to.matched.some(record => record.meta.app);

  store.state.app = app;

  if (app === false) {

    store.commit('closeModal');
    store.commit('clearResponse');
    store.commit('setHistory', to.path);

    let token = location.search.match(/token=([^&]*)/) || false;
    let key = localStorage.getItem('x-api-key') || false;

    if (token) {
      store.dispatch('loginUser', { key: token[1] });
    } else if (to.path !== '/login' && !key) {
      router.push('/login');
    } else {
      if (
        !Object.keys(store.getters.settings).length ||
        !Object.keys(store.getters._).length
      ) {
        await initialize();
      }
      next();
    }

  } else {
    next();
  }

})

export default router
